import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import InsightChip from './InsightChip';

const OutcomeInsights = ({
  relationshipCollection,
}) => {
  return (
    <FDStack spacing={1} wrap alignItems="flex-start" justifyContent="flex-start">
      {
        relationshipCollection.resources().list().map((insightResource) => (
          <InsightChip
            key={insightResource.id()}
            insightResource={insightResource}
          />
        ))
      }

    </FDStack>
  );
};

OutcomeInsights.defaultProps = {
};

OutcomeInsights.propTypes = {
  relationshipCollection: PropTypes.object.isRequired,
};

export default OutcomeInsights;
